export { FooterComponent } from './footer.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/footer/index.ts